




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Skill extends Vue {
  @Prop({ type: String, required: true })
  title!: string;
}
